<template>
    <div class="layout">
        <div class="left">
            Hiển thị
            <el-select
                class="select"
                size="small"
                v-model="soLuong"
                @change="onSizeChange"
                placeholder="Chọn"
            >
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
            </el-select>
            bản ghi/trang
        </div>

        <div class="right">
            <i class="records-info">
                Hiển thị từ
                <span>{{ start }} - {{ to }}</span>
                / <b>{{ formatNumber(total_rows) }} </b> bản ghi
            </i>
            <b-pagination
                class="pagination"
                :first-text="pagination.first_text"
                :limit="9"
                :last-text="pagination.last_text"
                :total-rows="total_rows"
                :prev-text="pagination.prev_text"
                :next-text="pagination.next_text"
                v-model="trangHienTai"
                @change="chonTrangHienThi"
                :per-page="pagination.limit"
                pills
            >
            </b-pagination>
        </div>
    </div>
</template>

<script>
import { BPagination } from 'bootstrap-vue'
import number_util from '@/utils/number_utils'

export default {
    name: 'CustomPagination',
    components: {
        BPagination
    },
    props: ['pageStart', 'tongbanghi', 'pageSize'],
    watch: {
        pageStart(newVal) {
            this.trangHienTai = newVal
            this.rebuild()
        },
        pageSize(newVal) {
            this.pagination.limit = newVal
            this.soLuong = newVal
            this.trangHienTai = 1
            this.rebuild()
        },
        tongbanghi: function (newVal) {
            this.total_rows = newVal
            this.rebuild()
        }
    },
    data() {
        return {
            trangHienTai: 1,
            pagination: {
                next_text: '»', // Fixed: next should be »
                prev_text: '«', // Fixed: prev should be «
                first_text: 'Đầu',
                last_text: 'Cuối',
                limit: 25
            },
            start: 0,
            to: 25,
            total_rows: 0,
            soLuong: 25,
            options: [
                {
                    value: 25,
                    label: '25'
                },
                {
                    value: 50,
                    label: '50'
                },
                {
                    value: 100,
                    label: '100'
                },
                {
                    value: 200,
                    label: '200'
                },
                {
                    value: 500,
                    label: '500'
                },
                {
                    value: 1000,
                    label: '1000'
                }
            ]
        }
    },
    mounted() {
        // Initialize from props
        this.trangHienTai = this.pageStart || 1
        this.pagination.limit = this.pageSize || 25
        this.soLuong = this.pageSize || 25
        this.total_rows = this.tongbanghi || 0
        this.rebuild()
    },
    methods: {
        chonTrangHienThi(number) {
            this.trangHienTai = number
            this.onPageChange()
        },
        formatNumber(num) {
            return number_util.formatNumberEx(num)
        },
        onPageChange() {
            let ret = {
                start: (this.trangHienTai - 1) * this.pagination.limit,
                limit: this.pagination.limit,
                currentPage: this.trangHienTai
            }
            this.rebuild()
            this.$emit('pageChange', ret)
        },
        rebuild() {
            this.start = (this.trangHienTai - 1) * this.pagination.limit + 1
            this.to = Math.min(
                this.trangHienTai * this.pagination.limit,
                this.total_rows
            )

            if (this.total_rows === 0) {
                this.start = 0
                this.to = 0
            }
        },
        onSizeChange() {
            this.pagination.limit = this.soLuong
            this.trangHienTai = 1
            let ret = {
                soluong: this.soLuong
            }
            this.$emit('pageSizeChange', ret)
            this.rebuild()
        }
    }
}
</script>

<style scoped>
.layout {
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.right {
    display: flex;
    align-items: center;
}
.records-info {
    color: var(--blue-200);
    margin-right: 10px;
}
.select {
    width: 75px !important;
    margin-right: 10px;
    margin-left: 10px;
}
.pagination {
    margin: 0;
}

.el-select-dropdown__item.selected {
    color: var(--white-common) !important;
    background: var(--blue-200) !important;
    font-weight: normal !important;
}

.el-select-dropdown__item:hover {
    color: var(--blue-200) !important;
    background: #f0f8ff !important;
}

.el-select-dropdown__item {
    color: #212529 !important;
}

::v-deep .b-pagination-pills .page-item .page-link {
    border-color: var(--gray-100) !important;
    color: var(--black-200);
}
::v-deep .page-item.active .page-link {
    color: var(--white-common);
    background: var(--blue-200);
}

@media (max-width: 768px) {
    .layout {
        flex-direction: column;
        align-items: flex-start;
    }
    .select {
        width: 100% !important;
        margin-right: 0;
        margin-left: 0;
        margin-bottom: 20px;
        margin-top: 10px;
    }
    .records-info {
        margin-top: 10px;
        width: 100%;
        text-align: left;
    }
}
</style>
